// import { route } from '@/js/libs/route'
import { useForm as useInertiaForm } from '@inertiajs/inertia-vue3';
import route from '@/types/Route';
export default function useExaminationForm(examination, initialFormData, postUrlName = null) {
    const form = useInertiaForm({ ...initialFormData });
    // 試験データがある場合、フォームに値をセットする
    Object.keys(initialFormData).forEach((key) => {
        if (examination.value && examination.value[key] !== undefined) {
            if (key === 'is_published' || key === 'is_auto_calc_result') {
                form[key] = Boolean(examination.value[key]);
            }
            else {
                form[key] = examination.value[key];
            }
        }
    });
    const onFormSubmit = () => {
        if (postUrlName === null || !examination.value?.id)
            return;
        form.put(route(postUrlName, { examination: examination.value.id }));
    };
    return {
        form,
        onFormSubmit,
    };
}
